<template>
	<div :id="this.id"></div>
</template>

<script>
	export default {
		name: "BasicBar",
		props: {
			myChart : null,
			id: "",
			titleText: "",
			seriesName: "",
			xAxisData: Array,
			seriesData: Array,
		},
		mounted: function() {},
		methods: {
			draw() {
				let newPromise = new Promise((resolve) => {
					resolve()
				})
				newPromise.then(() => {
					this.$echarts.dispose(document.getElementById(this.id));
					let myChart = this.$echarts.init(document.getElementById(this.id));
					let option = {
						title: {
							text: this.titleText,
							left: 'center',
						},
						tooltip: {
							trigger: 'axis',
							axisPointer: { // 坐标轴指示器，坐标轴触发有效
								type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
							}
						},
						grid: {
							left: '3%',
							right: '4%',
							bottom: '3%',
							containLabel: true
						},
						xAxis: [{
							type: 'category',
							data: this.xAxisData,
							axisTick: {
								alignWithLabel: true
							}
						}],
						yAxis: [{
							type: 'value'
						}],
						series: [{
							name: this.seriesName,
							type: 'bar',
							barWidth: '60%',
							data: this.seriesData,
						}]
					};

					myChart.setOption(option);
				})
			}
		},
		watch: {
			seriesData: {
				handler(val, oldVal) {
					this.draw();
				},
				deep: true,
				immediate: true,
			},
		},
		created(){
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ECharts/BasicBar.vue